import React from 'react';
import { Card, EmptyText } from 'library/ui';

export function BasicCard({ loading, children }: { loading: boolean; children: React.ReactNode }) {
    return <Card>{loading ? <EmptyText padding="md">Loading...</EmptyText> : children}</Card>;
}
